var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "P1-29",
    transform: "translate(-163.000000, -721.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ActionSheet",
    transform: "translate(0.000000, 336.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(163.000000, 385.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u03A9-/-Assembly-/-Containers-/-A-||-Pill"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u26F1-Shadow",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    rx: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83C\\uDFA8-Fill",
    fillOpacity: 0,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    rx: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83D\\uDD32-Stroke",
    strokeOpacity: 0.38,
    stroke: "#000000",
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.000000, 12.000000)",
    fill: "#000000",
    fillOpacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Close"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5454951,4.45450487 C19.9762205,4.88523019 19.984666,5.5783265 19.5708319,6.01934088 L19.5454951,6.04549513 L13.591,12 L19.5454951,17.9545049 C19.984835,18.3938447 19.984835,19.1061553 19.5454951,19.5454951 C19.1147698,19.9762205 18.4216735,19.984666 17.9806591,19.5708319 L17.9545049,19.5454951 L12,13.591 L6.04549513,19.5454951 C5.6061553,19.984835 4.8938447,19.984835 4.45450487,19.5454951 C4.02377955,19.1147698 4.01533395,18.4216735 4.42916809,17.9806591 L4.45450487,17.9545049 L10.409,12 L4.45450487,6.04549513 C4.01516504,5.6061553 4.01516504,4.8938447 4.45450487,4.45450487 C4.88523019,4.02377955 5.5783265,4.01533395 6.01934088,4.42916809 L6.04549513,4.45450487 L12,10.409 L17.9545049,4.45450487 C18.3938447,4.01516504 19.1061553,4.01516504 19.5454951,4.45450487 Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleClose);
export default __webpack_public_path__ + "static/media/circle-close.ac1a286d.svg";
export { ForwardRef as ReactComponent };